import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'ng-hbm-bdi-share',
  templateUrl: './share.component.html'
})
export class ShareComponent implements OnInit {

  linkUrl: string;
  image: string;
  copied: boolean = false;

  constructor(public modalService: ModalService, private user: UserService) { }

  ngOnInit(): void {
    const origin = this.modalService.currentDatas.rootUrl;
    const basePage = environment.magento.shareUrls[this.user.country].url;
    const finalPage = environment.magento.shareUrls[this.user.country].pages[this.user.context];
    const projectId = `project_id=${this.modalService.currentDatas.id}`;
    const configurator = `configurator=${this.user.context}`;

    this.linkUrl = `${origin}${basePage}${finalPage}?${projectId}&${configurator}`;
    this.image = this.modalService.currentDatas.image;
  }

  async copyToClipboard() {
    navigator.clipboard.writeText(this.linkUrl).then(
      () => {
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 1000);
      },
      () => { console.log("error copy!"); }
    );
  }
}
